import { motion } from "framer-motion";
import { Cpu, Briefcase, ArrowUpRight } from "lucide-react";
import { TECH_DOMAINS, INDUSTRY_DOMAINS, IMAGES, EXTERNAL_LINKS } from "@/lib/site-data";

function Chip({ label, i }) {
  return (
    <motion.span
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: i * 0.03 }}
      className="inline-flex items-center rounded-md border border-white/12 bg-white/[0.03] px-4 py-2.5 text-sm text-white/85 hover:border-primary/60 hover:text-white transition-colors duration-300"
      data-testid="domain-chip"
    >
      {label}
    </motion.span>
  );
}

export default function CorporateTraining() {
  return (
    <section id="training" className="relative bg-[hsl(215_35%_10%)] text-white py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.12]">
        <img src={IMAGES.corporate} alt="" className="h-full w-full object-cover" />
      </div>
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-16"
        >
          <span className="text-xs uppercase tracking-[0.3em] text-primary font-medium">
            Corporate Learning & Workforce Development
          </span>
          <h2 className="font-display text-4xl md:text-6xl mt-4 leading-[1.02]">
            Industry-aligned training for a technology-driven economy.
          </h2>
          <p className="text-white/65 mt-6 text-lg leading-relaxed">
            A trusted partner for enterprises, institutions and government
            organizations — programs designed and delivered by industry experts.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <Cpu className="text-primary" size={22} />
              <h3 className="font-display text-2xl text-white">Emerging Technology</h3>
            </div>
            <div className="flex flex-wrap gap-3">
              {TECH_DOMAINS.map((d, i) => (
                <Chip key={d} label={d} i={i} />
              ))}
            </div>
          </div>
          <div>
            <div className="flex items-center gap-3 mb-6">
              <Briefcase className="text-primary" size={22} />
              <h3 className="font-display text-2xl text-white">Domain-Specific Training</h3>
            </div>
            <div className="flex flex-wrap gap-3">
              {INDUSTRY_DOMAINS.map((d, i) => (
                <Chip key={d} label={d} i={i} />
              ))}
            </div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mt-16 flex flex-col sm:flex-row items-start sm:items-center gap-6 justify-between rounded-2xl border border-white/12 bg-white/[0.04] p-8"
        >
          <p className="font-display text-2xl md:text-3xl max-w-xl leading-snug">
            Build future-ready teams with Career Banale.
          </p>
          <a
            href={EXTERNAL_LINKS.careerbanale}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="training-cta"
            className="inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3.5 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors whitespace-nowrap"
          >
            Explore Career Banale <ArrowUpRight size={16} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
